import {BaseCriteriaModel} from '../base-criteria.model';
import {Optional} from 'typescript-optional';

export class BinExtQueryCriteriaClass extends BaseCriteriaModel {
  guid_hdr?: Optional<string> = Optional.empty();
  guid_line?: Optional<string> = Optional.empty();
  param_code?: Optional<string> = Optional.empty();
  param_name?: Optional<string> = Optional.empty();
  value_string?: Optional<string> = Optional.empty();
  value_numeric?: Optional<number> = Optional.empty();

}

export class BinExtCriteriaModelQuery {
  query = '';

  constructor(binExtCriteriaModel: BinExtQueryCriteriaClass) {

    if (!binExtCriteriaModel) {
      return;
    }

    this.query += binExtCriteriaModel.guid_hdr.filter(x => x !== '').map(x => '&guid_hdr=' + x).orElse('');
    this.query += binExtCriteriaModel.guid_line.filter(x => x !== '').map(x => '&guid_line=' + x).orElse('');
    this.query += binExtCriteriaModel.param_code.filter(x => x !== '').map(x => '&param_code=' + x).orElse('');
    this.query += binExtCriteriaModel.param_name.filter(x => x !== '').map(x => '&param_name=' + x).orElse('');
    this.query += binExtCriteriaModel.value_string.filter(x => x !== '').map(x => '&value_string=' + x).orElse('');
    this.query += binExtCriteriaModel.value_numeric.filter(x => x !== null).map(x => '&value_numeric=' + x).orElse('');

    this.query += '&status=' + binExtCriteriaModel.status;
    this.query += '&orderBy=' + binExtCriteriaModel.orderBy;
    this.query += '&order=' + binExtCriteriaModel.order;
    this.query += '&offset=' + binExtCriteriaModel.offset + '&limit=' + binExtCriteriaModel.limit;
  }
}
